import React from 'react';
import { withFormulas } from '../hocs/with-formulas';
import { ScoreContent, ScoreSubcomponents } from '../components';

export const ScoreCosts = ({formulas, className}) => {
  const costTitle = "AR Cost";
  const costSummary = "Accounts Receivable costs are a key factor in determining your overall AR health. Measuring the amount you spend on basic AR functions and comparing those costs against key revenue metrics provides insight into the efficiency of your finance operations."
  const getStarted = () => {
    window.open('https://www.paystand.com/ar-health-consult','_blank','resizable=yes');
  }

  return (
    <ScoreContent title={costTitle} summary={costSummary} className={className}>
      <div className="print--only-visible">
        <img src={require(`../../styles/img/${formulas.getArCostsScore()}_score.png`)} style={{width: "55px"}} alt="score-a"/>
      </div>
      <div className="health-graph">
        <ScoreSubcomponents title="Cost per invoice" health={formulas.getCostInvoiceHealth()}/>
        <ScoreSubcomponents title="Credit card rate" health={formulas.getCreditCardRateHealth()}/>
        <ScoreSubcomponents title="Cost predictability" health={formulas.getCostPredictabilityHealth()}/>
      </div>
      <div className="info">
        <span className="text-02-navy-blue">Recommended Reading</span>
        <p className="text-04-navy-blue-bold">Here are some helpful resources for creating more efficient and predictable cash flow.</p>
        <a className="text-04-sky-blue" href="https://www.paystand.com/blog/how-much-does-it-cost-business-to-accept-paper-checks" target="_blank" rel="noopener noreferrer">
          The True Cost of Paper Checks
        </a>
        <a className="text-04-sky-blue" href="https://cdn2.hubspot.net/hubfs/493201/1-Asset%20Library/Guides%20and%20eBooks/PayStand%20-%20Guide%20to%20Understanding%20Your%20Merchant%20Statement.pdf" target="_blank" rel="noopener noreferrer">
          Guide To Understanding Your Merchant Statement
        </a>
        <a  className="text-04-sky-blue" href="https://www.paystand.com/blog/what-is-zero-touch-payment-processing" target="_blank" rel="noopener noreferrer">
          What is Zero Touch payment processing?
        </a>
        <span className="text-02-navy-blue-bold">Ready to eliminate transaction fees?</span>
        <button onClick={getStarted}>Get Started</button>
      </div>
    </ScoreContent>

  )
}

export const ScoreCostsWithFormulas = withFormulas(ScoreCosts);
